import { render, staticRenderFns } from "./ThemeEditor.vue?vue&type=template&id=5bac68f2&scoped=true&"
import script from "./ThemeEditor.vue?vue&type=script&lang=ts&"
export * from "./ThemeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ThemeEditor.vue?vue&type=style&index=0&id=5bac68f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac68f2",
  null
  
)

export default component.exports